import React from "react";
import { Typography, styled, IconButton } from "@mui/material";
import VerticalAlignBottom from "@mui/icons-material/VerticalAlignBottom";
import DownloadIcon from "@mui/icons-material/Download";

const DownloadIconButton = styled(IconButton)(({ theme }) => ({
  fontSize: "14px",
  color: "#E56800",
  "&:hover": {
    textDecoration: "underline",
    background: "none",
  },
}));
function HelpComponent() {
  const generatePDF = () => {
    const url = ""; //File path under files folder
    const link = document.createElement("a");
    link.href = url;
    link.download = ""; // The name for the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <Typography className="prompt-library-titles">
        Help & resources
      </Typography>
      <Typography
        sx={{
          fontSize: "14px",
          paddingLeft: "10px",
          paddingTop: "16px",
          paddingBottom: "6px",
          whiteSpace: "pre-line",
          wordWrap: "break-word", // Ensures long words break and wrap onto the next line
          overflowWrap: "break-word",
          color: "#454545", // Same as wordWrap, ensures text wrapping
        }}
      >
        View support resources for understanding and navigating RepAssist
      </Typography>
      <DownloadIconButton
        sx={{ fontFamily: '"Mulish", sans-serif' }}
        //  onClick={generatePDF}
      >
        <DownloadIcon fontSize="small" sx={{ mr: "3px" }} />
        <span>Download document</span>
      </DownloadIconButton>
    </>
  );
}

export default HelpComponent;
